import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';

const CustomNavLink = ({ isActive, to, label, children, history, match, staticContext, ...props }) => {
    const classes = ['nav-item'];
    if(isActive)
        classes.push('active');

    return (
        <li className={classes.join(' ')}>
            <NavLink className="nav-link" activeClassName="active" to={to} {...props}>
                {children}
            </NavLink>
        </li>
    );
};

export default withRouter(({ location, ...props }) => {
    // props => { to: "/about", children: "INM", history: Object, match: Object, staticContext: undefined, ...ALL_OTHER_CUSTOM_PROPS }
    const isActive = location.pathname === props.to;
    return <CustomNavLink {...props} isActive={isActive} />;
});
